var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames, responsiveClassNames, } from "@bookingcom/bui-core/utilities/classNames";
import mixinClassNames from "../../utilities/mixinClassNames.js";
import { mixinStyles } from "@bookingcom/bui-core/utilities/styles";
import Button from "../Button/index.js";
import Stack from "../Stack/index.js";
import styles from "@bookingcom/bui-core/css/ActionBar.module.css";
var ActionBar = function (props) {
    var children = props.children, topContent = props.topContent, _a = props.topContentFill, topContentFill = _a === void 0 ? false : _a, button = props.button, fillEqually = props.fillEqually, _b = props.size, size = _b === void 0 ? "medium" : _b, _c = props.elevated, elevated = _c === void 0 ? false : _c, className = props.className, attributes = props.attributes, _d = props.verticalAlignment, verticalAlignment = _d === void 0 ? "center" : _d, mixin = props.mixin;
    var shouldButtonContainerGrow = !children || fillEqually;
    var rootClassName = classNames(styles.root, className, mixinClassNames(mixin));
    var containerClassName = classNames(styles.container, responsiveClassNames(styles, "container--size", size), responsiveClassNames(styles, "container--elevated", elevated));
    var rootAttributes = __assign(__assign({}, attributes), { style: __assign(__assign({}, ((attributes === null || attributes === void 0 ? void 0 : attributes.style) || {})), mixinStyles(mixin)) });
    return (React.createElement("div", __assign({}, rootAttributes, { className: rootClassName }),
        React.createElement(Stack, { direction: "column", gap: 2, className: containerClassName },
            topContent && (React.createElement(Stack.Item, { grow: true, className: classNames(styles["top-content"], topContentFill ? styles["top-content--fill"] : null) }, topContent)),
            React.createElement(Stack, { direction: "row", alignItems: verticalAlignment, gap: 2, className: styles.content },
                children && React.createElement(Stack.Item, { grow: true }, children),
                React.createElement(Stack.Item, { grow: shouldButtonContainerGrow }, button && React.createElement(Button, __assign({}, button, { wide: true })))))));
};
export default ActionBar;
